/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ModerationRejectedTombstoneContainer_comment = {
    readonly id: string;
    readonly " $refType": "ModerationRejectedTombstoneContainer_comment";
};
export type ModerationRejectedTombstoneContainer_comment$data = ModerationRejectedTombstoneContainer_comment;
export type ModerationRejectedTombstoneContainer_comment$key = {
    readonly " $data"?: ModerationRejectedTombstoneContainer_comment$data;
    readonly " $fragmentRefs": FragmentRefs<"ModerationRejectedTombstoneContainer_comment">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ModerationRejectedTombstoneContainer_comment",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
        }
    ],
    "type": "Comment",
    "abstractKey": null
} as any);
(node as any).hash = 'be970590006c8e577041a54d0eb13d8c';
export default node;
